require("./wdh-legacy/submenu-point-spot/js/corporate-template/component-submenu-point-spot.js");